interface HealthDataNavigationProps {
  categories: string[];
  activeCategory?: string;
  onCategoryClick: (category: string) => void;
}

export function HealthDataNavigation({
  categories,
  activeCategory,
  onCategoryClick
}: HealthDataNavigationProps) {
  return (
    <div className="w-full">
      <div
        className="h-[46px] px-3 overflow-x-auto overflow-y-clip relative shrink-0 w-full [&::-webkit-scrollbar]:hidden"
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
      >
        <div className="absolute contents left-0 top-0">
          <div className="flex gap-[14px] items-start min-w-full lg:w-full w-max">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => onCategoryClick(category)}
                className={`
                  box-border flex gap-[10px] h-[42px] items-center justify-center
                  overflow-clip px-[18px] py-[13px] relative shrink-0 lg:flex-1 rounded-[4px]
                  font-['Inter'] font-normal text-[14px] leading-[1.4] text-center
                  text-white whitespace-nowrap transition-all duration-200
                  ${activeCategory === category
                    ? 'bg-[rgba(124,241,199,0.25)]'
                    : 'bg-[rgba(255,255,255,0.15)] shadow-[0px_2px_48px_0px_rgba(0,0,0,0.04)] hover:bg-[rgba(255,255,255,0.25)]'
                  }
                `}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>
      </div>
  );
}
